/**
 * PipingProgressWalkthrough — thin wrapper around HelpVideoTour
 * for the curated piping new-employee tour (backward-compatible exports).
 *
 * Used from:
 *  - DisciplineMatrix help → “Video Tour” tab
 *  - Learning Center → Video Tutorials
 */

import React from 'react';
import HelpVideoTour, { HelpVideoTourModal } from './HelpVideoTour';
import { getHelpTour, PIPING_WALKTHROUGH_GUIDE_ID } from './helpTours/registry';

// Re-export from registry with the `export … from` form so CRA/webpack
// always sees these as named exports of this module.
export {
  PIPING_WALKTHROUGH_GUIDE_ID,
  PIPING_WALKTHROUGH_SCENES,
} from './helpTours/registry';

const PipingProgressWalkthrough = ({
  compact = false,
  autoStart = false,
  onClose,
  showHeader = true,
}) => {
  const tour = getHelpTour(PIPING_WALKTHROUGH_GUIDE_ID);
  if (!tour) return null;

  return (
    <HelpVideoTour
      guideId={tour.guideId}
      title={tour.title}
      accent={tour.accent}
      scenes={tour.scenes}
      compact={compact}
      showHeader={showHeader}
      autoStart={autoStart}
      onClose={onClose}
    />
  );
};

/** Full-screen modal wrapper for Learning Center / Help Center */
export const PipingProgressWalkthroughModal = ({ isOpen, onClose }) => {
  const tour = getHelpTour(PIPING_WALKTHROUGH_GUIDE_ID);
  return (
    <HelpVideoTourModal
      isOpen={isOpen}
      onClose={onClose}
      guideId={PIPING_WALKTHROUGH_GUIDE_ID}
      title={tour?.title}
      accent={tour?.accent}
      scenes={tour?.scenes}
      autoStart={false}
    />
  );
};

export default PipingProgressWalkthrough;
